import React, {useEffect, useState} from 'react';
import './TableSideFactor.scss';
import Select from "react-select";
import NumericFunction from "../../../../utils/NumericFunction";
import commaSeparator from "../../../../utils/CommaSeparator";
import numericFunction from "../../../../utils/NumericFunction";
import utilsFunction from "../../../../utils/utilsFunction";

const TableSideFactor = ({initialData , totalPriceTable , setTotalPriceTable}) => {

    const [options, setOption] = useState([])
    const [componentData, setComponentData] = useState([]);
    const [currentProduct, setCurrentProduct] = useState({});

    useEffect(() => {

        const temp = []
        initialData?.productList.forEach((v) =>
            temp.push({label: v.name, value: v.productId})
        )
        setOption(temp)

    }, [])

    const customStyles = {

        control: (provided: Record<string, unknown>) => ({
            ...provided,
            height: 42,
            '&:hover': {
                border: '1px solid var(--bg-gray-2, #DADADA)',
            },
            '&:focus': {
                border: '1px solid var(--bg-gray-2, #DADADA)',
            },
        }),

        option: (base, state) => ({
            ...base,
            color: state.isSelected ? "white" : "'var(--neutral-g-2, #646464)'",
            backgroundColor: state.isSelected ? "var(--secondary-s-3, #5A507B)" : "white",
            padding: ".5rem 3rem .5rem .5rem",
            cursor: "pointer",
            fontsize: '12'
        }),
    };

    useEffect(() => {
        let flag = 0;
        componentData.forEach((v) => flag = flag + ((+v.te * +v.ghVahed) - (+v.te * +v.offer)))
        setTotalPriceTable(flag)
    }, [componentData])

    function deleteRowHandler(productId) {
        let tempArray = componentData;
        tempArray = tempArray.filter(v => v.productId !== productId)
        setComponentData(tempArray)
    }

    const changeTe = (e, productId) => {

        const tempArray = [...componentData];
        for (let i = 0; i < tempArray.length; i++) {
            if (tempArray[i].productId === productId) {
                tempArray[i].te = numericFunction.p2e(e.target.value)
                break;
            }
        }
        setComponentData(tempArray)
    }

    const changeGh = (e, productId) => {

        const tempArray = [...componentData];
        for (let i = 0; i < tempArray.length; i++) {
            if (tempArray[i].productId === productId) {
                tempArray[i].ghVahed = utilsFunction.removeComma(numericFunction.p2e(e.target.value))
                break;
            }
        }
        setComponentData(tempArray)
    }

    const changeOf = (e, productId) => {

        const tempArray = [...componentData];
        for (let i = 0; i < tempArray.length; i++) {
            if (tempArray[i].productId === productId) {
                tempArray[i].offer = utilsFunction.removeComma(numericFunction.p2e(e.target.value))
                break;
            }
        }
        setComponentData(tempArray)
    }

    const addProductToTable = () => {

        const filterCheck = componentData.filter((d) => {
            const selectedItem = d.productId;
            return selectedItem.toLowerCase().includes(currentProduct.productId.toLowerCase());
        })

        if (filterCheck.length === 0) {
            const temp = [...componentData]
            temp.push(currentProduct)
            setComponentData(temp)
        }
    }

    return (
        <div className="main-table-side-factor">

            <div className="select-product">

                <div className="select-box-side">
                    <label>انتخاب کالا</label>
                    <Select options={options}
                            styles={customStyles}
                            defaultValue={{label: "نام کالا را انتخاب کنید", value: "0"}}
                            onChange={(e) => {
                                const filtered = initialData.productList.filter((item) => {
                                    const selectedItem = item.productId;
                                    return selectedItem.toLowerCase().includes(e.value.toLowerCase());
                                });
                                setCurrentProduct(filtered[0])
                            }}/>
                </div>

                <div className="add-product-svg" onClick={addProductToTable}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                        <path
                            d="M15.3333 12.2188H7.66667C7.27376 12.2188 6.94792 11.8929 6.94792 11.5C6.94792 11.1071 7.27376 10.7812 7.66667 10.7812H15.3333C15.7263 10.7812 16.0521 11.1071 16.0521 11.5C16.0521 11.8929 15.7263 12.2188 15.3333 12.2188Z"
                            fill="white"/>
                        <path
                            d="M11.5 16.0521C11.1071 16.0521 10.7812 15.7262 10.7812 15.3333V7.66666C10.7812 7.27374 11.1071 6.94791 11.5 6.94791C11.8929 6.94791 12.2188 7.27374 12.2188 7.66666V15.3333C12.2188 15.7262 11.8929 16.0521 11.5 16.0521Z"
                            fill="white"/>
                        <path
                            d="M14.375 21.8021H8.625C3.42126 21.8021 1.19792 19.5787 1.19792 14.375V8.62499C1.19792 3.42124 3.42126 1.19791 8.625 1.19791H14.375C19.5788 1.19791 21.8021 3.42124 21.8021 8.62499V14.375C21.8021 19.5787 19.5788 21.8021 14.375 21.8021ZM8.625 2.63541C4.20709 2.63541 2.63542 4.20707 2.63542 8.62499V14.375C2.63542 18.7929 4.20709 20.3646 8.625 20.3646H14.375C18.7929 20.3646 20.3646 18.7929 20.3646 14.375V8.62499C20.3646 4.20707 18.7929 2.63541 14.375 2.63541H8.625Z"
                            fill="white"/>
                    </svg>
                </div>

            </div>

            <div className="table-factor">

                <ul className="header-side">
                    <li style={{width: "5%"}}>کد کالا</li>
                    <li style={{width: "20%"}}>عنوان کالا</li>
                    <li style={{width: "10%"}}>تعداد</li>
                    <li style={{width: "15%"}}>قیمت واحد</li>
                    <li style={{width: "15%"}}>تخفیف</li>
                    <li style={{width: "15%"}}>وضعیت مرجوعی</li>
                    <li style={{width: "15%"}}>جمع کل</li>
                    <li style={{width: "5%"}}>عملیات</li>
                </ul>

                {componentData.length > 0 &&
                    componentData.map((v, index) =>
                        <ul className="row-side" key={"row" + index}>
                            <li style={{width: "5%"}}>{NumericFunction.e2p(v?.productId)}</li>
                            <li style={{width: "20%"}}>{v?.name}</li>
                            <li style={{width: "10%"}}>
                                <input type="text" value={NumericFunction.e2p(v?.te)}
                                       onChange={e => changeTe(e, v.productId)}/>
                            </li>
                            <li style={{width: "15%"}}>
                                <input type="text" value={NumericFunction.e2p(commaSeparator(v?.ghVahed))}
                                       onChange={e => changeGh(e, v.productId)}/>
                            </li>
                            <li style={{width: "15%"}}>
                                <input type="text" value={NumericFunction.e2p(commaSeparator(v?.offer))}
                                       onChange={e => changeOf(e, v.productId)}/>
                            </li>
                            <li style={{width: "15%"}}>{v?.vzReject}</li>
                            <li style={{width: "15%"}}>
                                {NumericFunction.e2p(commaSeparator((+v?.te * +v?.ghVahed) - (+v?.te * +v?.offer)))}
                            </li>
                            <li style={{width: "5%"}} className={"delete-side"}
                                onClick={() => deleteRowHandler(v.productId)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"
                                     fill="none">
                                    <g opacity="0.99">
                                        <path
                                            d="M15.1829 16.2435L6.69764 7.75826C6.40772 7.46834 6.40772 6.98751 6.69764 6.6976C6.98755 6.40768 7.46838 6.40768 7.7583 6.6976L16.2436 15.1829C16.5335 15.4728 16.5335 15.9536 16.2436 16.2435C15.9537 16.5335 15.4728 16.5335 15.1829 16.2435Z"
                                            fill="#F84459"/>
                                        <path
                                            d="M6.69758 16.2435C6.40767 15.9536 6.40767 15.4728 6.69758 15.1829L15.1829 6.6976C15.4728 6.40768 15.9536 6.40768 16.2435 6.6976C16.5334 6.98751 16.5334 7.46834 16.2435 7.75826L7.75824 16.2435C7.46833 16.5335 6.9875 16.5335 6.69758 16.2435Z"
                                            fill="#F84459"/>
                                    </g>
                                </svg>
                            </li>
                        </ul>
                    )}
            </div>

            <hr/>

            <div className="total-price-table">
                <div className="box-price">
                    <p>جمع کل </p>
                    <p>{NumericFunction.e2p(commaSeparator(totalPriceTable))}</p>
                </div>
            </div>

        </div>
    );
};

export default TableSideFactor;